import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { btnPrimary } from "@/components/kit";

export default function NotFound() {
  return (
    <>
      {/* Page d'erreur : pas de canonical (jamais vers l'accueil), pas d'indexation */}
      <Helmet>
        <title>Page introuvable — Désir Events</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="flex min-h-screen flex-col items-center justify-center px-5 text-center">
        <span className="font-serif text-[9rem] font-medium leading-none text-lime-dim md:text-[14rem]">404</span>
        <h1 className="mt-4 font-serif text-3xl text-ink">Cette page n'existe pas.</h1>
        <p className="mt-3 max-w-md text-ink/50">Le lien que vous avez suivi est peut-être rompu, ou la page a été déplacée.</p>
        <Link to="/" className={`${btnPrimary} mt-8`} data-testid="notfound-home-btn">Retour à l'accueil</Link>
      </div>
    </>
  );
}
